import React, {Component} from 'react';
import {Modal, Spin, message } from 'antd';
import {delResource, loadInterviewResource, pictureConvertParams} from "../../actions/interview";
import TaskUpload from "../../view/components/taskUpload/taskUpload";
import UploadWall from "../upload/UploadWall";
import {Scrollbars} from "react-custom-scrollbars";
import {PIC_TYPE} from "../../constants/index";

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}


class NewsActivityPicture extends Component {

    state = {
        load: false,//是否加载完成
        previewVisible: false,
        previewImage: '',
        fileList: [],
    };

    componentDidMount() {
        this.loadFileList(this.props.data);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.loadFileList(nextProps.data);
    }



    loadFileList = (data)=>{
        if(data && data.id > 0){
            //加载采访任务的资源 
            loadInterviewResource(data.id, (res)=>{
                this.setState({
                    load:true,
                    fileList:(()=>{
                        let fileList = [];
                        res && res.pictureList && res.pictureList.map((item)=>{
                            if(item){
                                fileList.push({
                                    resourceId:item.resourceId,
                                    uid: parseInt(item.id) * -1,
                                    name: item.name,
                                    status: 'done',
                                    url: item.path,
                                })
                            }
                        });
                        return fileList;
                    })()
                })
            })
        }else{
            this.setState({
                load: true,
            });
            message.error("加载出错");
        }
    };

    handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }

        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
        });
    };

    handleChange = ({ file, fileList }) => {
        if(file.status === "done"){
            file.response.interviewId = this.props.data ? this.props.data.id : 0;
            pictureConvertParams(file.response, file, (res)=>{
                let newFileList = fileList.map(item=>{
                    if(item.uid === file.uid){
                        item.resourceId = res.resourceId;
                        item.url = res.path;
                    }
                    return item;
                });
                this.setState({ fileList:newFileList });
            });
        }
        this.setState({ fileList });
    };

    handleRemove = async file => {
        delResource(this.props.data.id, file.resourceId);
        this.setState(prevState => {
            let fileList = prevState.fileList.filter(item=>{
                return item.uid !== file.uid
            });
            return {
                fileList
            }
        });
    };

    /**
     * 是否有上传的权限
     * @param newsActivity
     * @param currentUser
     * @returns {boolean}
     */
    isHaveUploadAuth=(newsActivity, currentUser)=>{
        let auth = false;
        if(newsActivity && currentUser && (newsActivity.status < 3)){
            //查看当前的记者有哪些角色
            if(newsActivity.interviewJointers){
                newsActivity.interviewJointers.map(jointer=>{
                    if(jointer.account === currentUser.account){
                        //判断是否已经领取了
                        if((jointer.status < 3) && (jointer.interviewRole === 2)){//是摄影记者并且已领取才显示
                            auth = true;
                        }
                    }
                });
            }
        }
        return auth;
    };

    render() {
        const { previewVisible, previewImage, fileList, load } = this.state;
        return (
            <div style={{ padding: 15, background: '#f4f6fc' }}>
                <TaskUpload
                    fileType={2}
                    icons={["eye", "download", "delete"]}
                    taskId={this.props.data.id}
                    data={this.props.data}
                />
            </div>
        );
    }
}

export default NewsActivityPicture;